import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLanguageFromLocalStorage } from "@/utils/pureFunctions";
import messages from "./messages/index";

Vue.use(VueI18n);

export default new VueI18n({
  locale: getLanguageFromLocalStorage("lang", "uz"),
  messages,
  fallbackLocale: "uz",
  warnHtmlInMessage: "off",
  disableNoTranslationWarning: true,
});
